/**
 * The lesson settings panel on a narrow phone. It sits 10px in from the left and
 * was at least 364px wide (its 300px volume rows plus 32px of padding a side),
 * so on a 320px screen it ran about 54px past the right edge. Under 400px wide
 * the panel now keeps 8px clear of the right edge, its side padding comes in to
 * 16px, and the volume rows take the room that leaves. Wider screens are as before.
 */

export const SETTINGS_PANEL_LEFT_PX = 10;
const SCREEN_MARGIN_PX = 8;
const NARROW_SIDE_PADDING_PX = 16;
const VOLUME_ROWS_MIN_PX = 300;

/** Screens under this width get the narrow padding. */
export const SETTINGS_PANEL_NARROW_SCREEN_PX = 400;
export const SETTINGS_PANEL_NARROW_QUERY = `@media (max-width: ${SETTINGS_PANEL_NARROW_SCREEN_PX - 0.02}px)`;

/** The panel's widest: the screen less its left offset and an 8px right margin. */
export const SETTINGS_PANEL_MAX_WIDTH = `calc(100vw - ${SETTINGS_PANEL_LEFT_PX + SCREEN_MARGIN_PX}px)`;

/** Side padding: 32px, or 16px on a narrow screen. */
export const settingsPanelPaddingSx = {
  paddingInline: '32px',
  [SETTINGS_PANEL_NARROW_QUERY]: { paddingInline: `${NARROW_SIDE_PADDING_PX}px` },
} as const;

/** The volume rows' least width: 300px, or what a narrow screen's panel has inside. */
export const SETTINGS_PANEL_VOLUME_MIN_WIDTH = `min(${VOLUME_ROWS_MIN_PX}px, calc(100vw - ${
  SETTINGS_PANEL_LEFT_PX + SCREEN_MARGIN_PX + 2 * NARROW_SIDE_PADDING_PX
}px))`;
